import React, { useState } from "react";
import {
  Container,
  ContainerView,
  TitlePage,
} from "../../components/Container";
import { useApp } from "../../contexts";
import TabsCustom from "../../components/TabsCustom";
import { Tabs } from "antd";
import { useWindowSize } from "../../hook/useWindowSize";
import { TabCollections } from "./components/TabCollections";
import { TabPages } from "./components/TabPages";

export const generateOption = {
  collections: "collections",
  pages: "pages"
};

export const AffiliateGenerate = () => {
  const { T, user } = useApp();
  const [tab, setTab] = useState(generateOption.collections);
  const size = useWindowSize();

  return (
    <Container>
      <ContainerView background="transparent">
        <TitlePage>{T("Generate your affiliate links")}</TitlePage>
        <div
          className="flex justify-between items-center lg:bg-white lg:rounded-[36px]
           py-[15px] lg:px-[30px] lg:py-[30px] xls:px-[50px] xls:py-[27px] lg:mt-[30px] xls:mt-[40px]"
          >
        <TabsCustom
          spaceItem={size.width > 1024 ? 32 : 30}
          className="v2 w-full"
          activeKey={tab}
          onChange={(e) => setTab(e)}
          destroyInactiveTabPane={true}
        >
          <Tabs.TabPane tab={T("Link to Collection")} key={generateOption.collections}>
            <TabCollections tab={generateOption.collections} />
          </Tabs.TabPane>

          <Tabs.TabPane tab={T("Link to Any Page")} key={generateOption.pages}>
            <TabPages tab={generateOption.pages} />
          </Tabs.TabPane>
        </TabsCustom>
        </div>
        
      </ContainerView>
    </Container>
  );
};
